export default "__VITE_ASSET__a346f877__"